<template>
  <b-modal
    id="catalog-material"
    ref="fromCatalogModal"
    centered
    hide-footer
    v-model="showModal"
    size="xl"
    title="Agregar desde Catálogo"
    no-close-on-backdrop
    no-close-on-esc
    @close="onModalClose()"
  >
    <div
      class="row mt-3"
    >
      <div class="col-12">
        <b-list-group>
          <b-list-group-item
            id="catalog"
            v-b-toggle.catalog-accordion
            button
            class="d-flex justify-content-between align-items-center"
            role="tab"
            @click="onActiveAccordion"
          >
            Seleccione Catálogo
            <div>
              <em v-if="this.activeAccordionId ==='catalog'"
                 class="fa fa-chevron-up"
              ></em>
              <em v-else
                 class="fa fa-chevron-down"
              ></em>
            </div>
          </b-list-group-item>
          <b-collapse
            id="catalog-accordion"
            accordion="my-accordion"
            role="tabpanel"
            visible
            block
          >
            <b-table
              class="h-100"
              ref="selectableTable"
              :fields="fieldCatalog"
              :items="listCatalogsRender"
              hover
              select-mode="single"
              selectable
              sticky-header
              @row-selected="onRowSelected"
            >
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                </template>
              </template>
              <template #cell(catalogName)="row">
                {{ row.item.catalogName }}
              </template>
              <template #cell(catalogCategory)="row">
                <vs-chip
                  v-for="category of row.item.catalogCategory"
                  :key="category.id"
                  title="Categoría"
                  v-tooltip="'Categoría'"
                  class="mt-3"
                >
                  <vs-avatar icon="description" color="#ff9f43" />
                  {{ category }}
                </vs-chip>
              </template>
              <template #cell(catalogTotalMaterial)="row">
                {{ parseInt(row.item.catalogTotalMaterial) | toCurrency }}
              </template>
              <template #cell(catalogServices)="row">
                <vs-chip
                  v-for="service of row.item.catalogServices"
                  :key="service.id"
                  title="rut"
                  v-tooltip="'Servicio'"
                  class="mt-3"
                >
                  <vs-avatar icon="description" color="#ff9f43" />
                  {{ service.nombre }}
                </vs-chip>
              </template>
              <template #cell(actions)="row">
                <b-button
                  class="btn btn-primary pull-right ml-3"
                  @click="detailCatalog(row)"
                >
                  <strong>Detalle Catálogo</strong>
                </b-button>
              </template>
            </b-table>
          </b-collapse>
          <b-list-group-item
            id="material"
            v-b-toggle.material-accordion
            button
            class="d-flex justify-content-between align-items-center"
            role="tab"
          >
            <div>
              Detalle Catálogo
            </div>
            <div class="align-items-center">
              <strong> {{ catalogName }} </strong>
            </div>
            <div>
              <em v-if="this.activeAccordionId ==='material'"
                 class="fa fa-chevron-up"
              ></em>
              <em v-else
                 class="fa fa-chevron-down"
              ></em>
            </div>
          </b-list-group-item>
          <b-collapse
            id="material-accordion"
            accordion="my-accordion"
            role="tabpanel"
            :visible="this.activeAccordionId === 'material'"
          >
            <b-table
              class="h-100"
              :fields="fieldMaterial"
              :items="selectedMaterial"
            >
              <template #cell(SKU)="row">
                {{ row.item.SKU }}
              </template>
              <template #cell(nombre)="row">
                {{ row.item.nombre }}
              </template>
              <template #cell(categoria)="row">
                {{ row.item.categoria[0].descripcion }}
              </template>
              <template #cell(marca)="row">
                {{ row.item.marca.descripcion }}
              </template>
              <template #cell(cantidad)="row">
                {{ parseInt(row.item.cantidad) }}
              </template>
              <template #cell(cantidadSolicitar)="row">
                <b-form-input
                  type="number"
                  class="w-100"
                  v-model.number="row.item.cantidadSolicitar"
                  data-vv-as="Cantidad"
                  name="cantidad"
                  v-validate="`required|numeric|min_value:1|max_value:${quantityMax}`"
                  @change="totalRequest(row)"
                />
              </template>
              <template #cell(precio)="row">
                {{ parseInt(row.item.precio) | toCurrency }}
              </template>
              <template #cell(total)="row">
                {{ parseInt(row.item.total) | toCurrency }}
              </template>
              <template #cell(totalSolicitar)="row">
                {{ parseInt(row.item.totalSolicitar) | toCurrency }}
              </template>
            </b-table>
          </b-collapse>
        </b-list-group>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <b-avatar
          size="30"
          variant="warning"
        >
          <feather-icon
            size="22"
            icon="AlertCircleIcon"
          />
        </b-avatar>
        <label class="ml-1">Los materiales serán cargados a cada una de las entidades</label>
        <b-button
          class="btn pull-right ml-3"
          size="sm"
          @click="onModalClose"
        >
          Cancelar
        </b-button>
        <b-button
          class="btn btn-primary pull-right ml-3"
          size="sm"
          @click="addMaterialEntity"
        >
          Guardar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MaterialTableFields from '@/febos/global/materialsRequests/mixins/MaterialTableFields';

export default {
  name: 'PopUpAddFromCatalog',
  data() {
    return {
      listCatalogsRender: [],
      selectedCatalog: [],
      selectedMaterial: [],
      activeAccordionId: 'catalog',
      catalogName: '',
      quantityMax: 100,
      fieldCatalog: [
        { key: 'selected', label: '' },
        { key: 'catalogName', label: 'Catálogos' },
        { key: 'catalogCategory', label: 'Categorías' },
        { key: 'catalogQtyMaterial', label: 'Cantidad Materiales' },
        { key: 'catalogServices', label: 'Servicios' },
        { key: 'catalogTotalMaterial', label: 'Monto Total' },
        { key: 'actions', label: '' }
      ],
      fieldMaterial: MaterialTableFields.fieldMaterial,
    };
  },
  mounted() {
    this.searchListCatalog();
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Materials', [
      'loading',
      'listCatalogs',
    ]),
    showModal: {
      get() {
        return this.modalName === 'PopUpAddFromCatalog';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'loadListCatalogs'
    ]),
    onModalClose() {
      this.closeModal();
    },
    onRowSelected(item) {
      if (item.length === 0) this.onActiveAccordion();
      else {
        [this.selectedCatalog] = item;
        this.selectedMaterial = (this.selectedCatalog.catalogMaterials || []);
        this.catalogName = this.selectedCatalog.catalogName;
      }
    },
    onActiveAccordion() {
      this.activeAccordionId = 'catalog';
    },
    detailCatalog(row) {
      this.$refs.selectableTable.selectRow(row.index);
      this.activeAccordionId = 'material';
      this.onRowSelected([row.item]);
    },
    async searchListCatalog() {
      const query = {
        params: {
          filtros: 'estado:active'
        }
      };
      await this.loadListCatalogs(query);
      this.listCatalogsRender = this.listCatalogs.map((catalogo) => ({
        catalogId: catalogo.catalogId,
        catalogName: catalogo.catalogName,
        catalogServices: catalogo.catalogServices,
        catalogCategory: catalogo.catalogCategorys.map(
          (categoria) => categoria.descripcion
        ),
        catalogQtyMaterial: catalogo.catalogMaterials.map(
          (material) => material.cantidad
        ).reduce((a, b) => a + b, 0),
        catalogTotalMaterial: catalogo.catalogMaterials.map(
          (material) => material.cantidad * material.precio
        ).reduce((a, b) => a + b, 0),
        catalogMaterials: catalogo.catalogMaterials.map((material) => ({
          ...material,
          cantidadSolicitar: material.cantidad,
          total: (material.precio * material.cantidad),
          totalSolicitar: (material.precio * material.cantidad)
        }))
      }));
    },
    addMaterialEntity() {
      if (this.selectedCatalog.catalogMaterials
        .find((data) => data.cantidadSolicitar < 0 || data.cantidadSolicitar > this.quantityMax)) {
        this.notify(`Cantidad no puede ser negativo y no puede ser mayor a ${this.quantityMax}`);
        return;
      }
      const catalogMaterial = {
        idCatalog: this.selectedCatalog.catalogId,
        nombreCatalogo: this.selectedCatalog.catalogName,
        materiales: this.selectedCatalog.catalogMaterials
      };
      this.$emit('reload', catalogMaterial);
      this.closeModal();
    },
    totalRequest(row) {
      const material = row;
      if (material.item.cantidadSolicitar < 0) {
        this.notify('Cantidad no puede ser negativo');
      }
      if (material.item.cantidadSolicitar > 100) {
        this.notify(`Cantidad no puede ser mayor a ${this.quantityMax}`);
      }
      material.item.totalSolicitar = (row.item.cantidadSolicitar * row.item.precio);
    },
    notify(message) {
      this.$bvToast.toast(
        message,
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
    }
  }
};
</script>

<style scoped>

</style>
